import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-fetal-medicine-scans',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './fetal-medicine-scans.component.html',
  styleUrl: './fetal-medicine-scans.component.scss'
})
export class FetalMedicineScansComponent implements OnInit {

  constructor(
    private route: Router,
    private routes: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {

    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/fetal-medicine-scans",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);

    this.titleService.setTitle('Fetal Medicine Scans in Kannur | Expert Fetal Health Assessment');
    this.metaService.updateTag({
      name: 'description',
      content: "Ensure your baby's well-being with advanced fetal medicine scans at NCARE IVF Centre in Kannur. Our specialists offer detailed anomaly scans, NT scans, and targeted imaging for high-risk pregnancies."
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'fetal medicine scans, fetal anomaly scan, fetal medicine scan, fetal medicine scan centre, fetal scan centres near me'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Fetal Medicine Scans in Kannur | Expert Fetal Health Assessment'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: "Ensure your baby's well-being with advanced fetal medicine scans at NCARE IVF Centre in Kannur. Our specialists offer detailed anomaly scans, NT scans, and targeted imaging for high-risk pregnancies."
    });
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
